class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.inputs = Array.from(this.querySelectorAll('input[data-predictive-search]'));
        this.closeSearch = this.querySelector('.close--search');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        this.inputs.forEach(input => {
            input.addEventListener('input', this.debounce((event) => {
                this.onChange(event);
            }, 300).bind(this));
        });

        if (this.closeSearch) {
            this.closeSearch.addEventListener('click', this.close.bind(this));
        }
    }

    onChange(event) {
        const searchTerm = event.target.value.trim();
        if (!searchTerm.length) {
            this.close();
            return;
        }
        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        // this.querySelector('.search--spinner-default').classList.add('hidden');
        this.querySelector('.search--spinner').classList.remove('hidden');

        fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
            .then((response) => response.json())
            .then((suggestions) => {
                const resourceSuggestions = suggestions.resources;
                this.open();
                this.querySelector('.collectionSuggestions--results').innerHTML = '';
                this.querySelector('.productSuggestions--results').innerHTML = '';
                this.querySelector('.pageSuggestions--results').innerHTML = '';
                let collections = resourceSuggestions.results.collections;
                if (collections.length > 0) {
                    this.querySelector('#collectionSuggestions').classList.remove('hidden');
                    collections.forEach(collection => {
                        this.querySelector('.collectionSuggestions--results').insertAdjacentHTML("beforeend", this.simpleTemplate(collection));
                    });
                } else {
                    this.querySelector('#collectionSuggestions').classList.add('hidden');
                }
                let products = resourceSuggestions.results.products;
                if (products.length > 0) {
                    this.querySelector('#productSuggestions').classList.remove('hidden');
                    this.querySelector('#viewAllResults').classList.remove('hidden');
                    products.forEach(product => {
                        this.querySelector('.productSuggestions--results').insertAdjacentHTML("beforeend", this.productTemplate(product));
                    });
                } else {
                    this.querySelector('#productSuggestions').classList.add('hidden');
                    this.querySelector('#viewAllResults').classList.add('hidden');
                }

                let pages = resourceSuggestions.results.pages;
                if (pages.length > 0) {
                    this.querySelector('#pagesSuggestions').classList.remove('hidden');
                    pages.forEach(page => {
                        this.querySelector('.pageSuggestions--results').insertAdjacentHTML("beforeend", this.simpleTemplate(page));
                    });
                } else {
                    this.querySelector('#pagesSuggestions').classList.add('hidden');
                }

                if (collections.length === 0 && pages.length === 0 && products.length === 0) {
                    this.querySelector('#noResults').classList.remove('hidden');
                } else {
                    this.querySelector('#noResults').classList.add('hidden');
                }

            });
    }

    open() {
        const predictiveSearchElement = this.querySelector('#predictive-search');
        const headerElement = document.querySelector('[data-header]');
        predictiveSearchElement.classList.remove('hidden');

        const headerHeight = headerElement.offsetHeight;
        predictiveSearchElement.style.height = (window.innerHeight - headerHeight) + 'px';
        // this.querySelector('.search--spinner-default').classList.remove('hidden');
        this.querySelector('.search--spinner').classList.add('hidden');

        if (document.querySelector('[data-announcement-bar-wrapper]')) {
            const searchWrapper = this.querySelector('#predictive-search');
            searchWrapper.style.top = 'var(--header-height)';
        }
    }

    close() {
        this.querySelector('#predictive-search').classList.add('hidden');
    }

    simpleTemplate(data) {
        return `
            <li class="block text-lg">
                <a class="hover:text-orange-900" href="${data.url}">
                    ${data.title}
                </a>
            </li>
        `;
    }

    productTemplate(data) {
        // console.log(data)
        // Template.
        let template = $("#product-item").html()
        // Compile the template
        let instance = Handlebars.compile(template)
        // Create template
        let output = instance({ 'product' : data })
        return output;
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
